export const api = "/api/v1"

export const mobileSizeRaw = "max-width: 479px"